<div class="ocr-document-step">

  <!-- ==================== SELECCION DE TIPO DE DOCUMENTO ==================== -->
  <ng-container *ngIf="currentSubStep === 'select-document'">
    <p class="main-question">
      <strong>Selecciona tu tipo de documento</strong>
    </p>
    <p class="subtext">
      El documento define la moneda que podrás depositar. Elige el del país donde
      tienes tu cuenta bancaria.
    </p>

    <!-- Aviso: el documento decide con qué moneda se fondea -->
    <div class="info-note">
      <span class="info-icon" aria-hidden="true">i</span>
      <p>
        ¿Vas a enviar una remesa? Fondea con el documento del país donde tienes el
        dinero.
      </p>
    </div>

    <div class="document-options">
      <!-- Opcion Chile -->
      <button
        type="button"
        class="document-option"
        (click)="selectDocumentType('chile')"
        [disabled]="loading"
      >
        <img src="assets/img/runChile.png" alt="Cédula chilena" class="option-image" />
        <div class="option-info">
          <span class="option-title">Cédula chilena (RUT)</span>
          <span class="option-currency">Depósitos en <strong>CLP</strong> · pesos</span>
          <span class="option-desc">Emitida en Chile</span>
        </div>
      </button>

      <!-- Opcion Venezuela -->
      <button
        type="button"
        class="document-option"
        (click)="selectDocumentType('venezuela')"
        [disabled]="loading"
      >
        <img src="assets/img/cedulaVenezuela.png" alt="Cédula venezolana" class="option-image" onerror="this.src='assets/img/runChile.png'" />
        <div class="option-info">
          <span class="option-title">Cédula venezolana</span>
          <span class="option-currency">Depósitos en <strong>VES</strong> · bolívares</span>
          <span class="option-desc">Emitida en Venezuela</span>
        </div>
      </button>
    </div>

    <!-- Doble nacionalidad: una cuenta por documento -->
    <div class="dual-note">
      <p class="dual-title">
        ¿Tienes ambas nacionalidades?
        <span class="dual-badge">doble</span>
      </p>
      <p class="dual-text">
        Abre una cuenta con cada documento usando un correo distinto: fondeas pesos
        con la chilena y bolívares con la venezolana.
      </p>
    </div>

    <!-- Boton volver -->
    <div class="actions">
      <button type="button" class="back-btn" (click)="goBack()" [disabled]="loading">
        Volver
      </button>
    </div>
  </ng-container>

  <!-- ==================== CAPTURA DE DOCUMENTO (FRONTAL/TRASERO) ==================== -->
  <ng-container *ngIf="currentSubStep === 'capture-front' || currentSubStep === 'capture-back'">
    <!-- Indicador de fase para Chile -->
    <div class="phase-indicator" *ngIf="showPhaseIndicator">
      <span class="phase-badge">{{ phaseIndicator }}</span>
    </div>

    <p class="main-question">
      <ng-container *ngIf="currentSubStep === 'capture-back'; else frontTitle">
        <strong>Ahora captura el <span class="highlight-reverso">REVERSO</span> de tu documento</strong>
      </ng-container>
      <ng-template #frontTitle>
        <strong>{{ captureTitle }}</strong>
      </ng-template>
    </p>
    <p class="subtext">
      <ng-container *ngIf="currentSubStep === 'capture-back'">
        Da vuelta tu cedula chilena y toma una foto del <strong>reverso</strong> (parte trasera).
      </ng-container>
      <ng-container *ngIf="currentSubStep !== 'capture-back'">
        {{ captureSubtext }}
      </ng-container>
    </p>

    <!-- Vista previa de imagen capturada -->
    <div *ngIf="currentImage" class="preview">
      <p class="subtext">Vista previa</p>

      <div class="preview-wrapper">
        <div class="image-container">
          <img
            [src]="currentImage"
            [style.transform]="'rotate(' + rotationAngle + 'deg)'"
            alt="Documento capturado"
          />
          <div class="overlay-text">
            Para uso exclusivo de verificacion de identidad
          </div>
        </div>
      </div>

      <div class="preview-controls">
        <button type="button" (click)="rotateLeft()" [disabled]="loading">
          <mat-icon>rotate_left</mat-icon>
        </button>
        <button
          type="button"
          class="confirm-btn"
          (click)="confirmDocument()"
          [disabled]="loading"
        >
          {{ loading ? 'Procesando...' : 'Confirmar' }}
        </button>
        <button type="button" (click)="rotateRight()" [disabled]="loading">
          <mat-icon>rotate_right</mat-icon>
        </button>
      </div>

      <button
        type="button"
        class="retake-btn"
        (click)="retakeImage($event)"
        [disabled]="loading"
      >
        Tomar otra foto
      </button>
    </div>

    <!-- Imagen de ejemplo -->
    <div class="example-wrapper" *ngIf="!currentImage">
      <img
        [src]="exampleImage"
        alt="Ejemplo de documento"
        class="example-image"
        [class.reverso-example]="isBackCapture"
        onerror="this.src='assets/img/runChile.png'"
      />
      <p class="example-label" *ngIf="!isBackCapture">
        Ejemplo de documento frontal
      </p>
      <p class="example-label reverso-label" *ngIf="isBackCapture">
        <strong>REVERSO</strong> - Parte trasera del documento
      </p>
    </div>

    <!-- Recomendaciones -->
    <div class="recommendation-box">
      <p class="title">Recomendaciones</p>
      <ul>
        <li>
          <span class="icon">&#10004;</span>
          Utilice una identificacion con fotografia valida emitida por el gobierno.
        </li>
        <li>
          <span class="icon">&#10004;</span>
          Toma la imagen en un espacio bien iluminado.
        </li>
        <li *ngIf="currentSubStep === 'capture-front'">
          <span class="icon">&#10004;</span>
          Asegurate de que todos los datos sean legibles.
        </li>
        <li *ngIf="currentSubStep === 'capture-back'">
          <span class="icon">&#10004;</span>
          Captura el reverso completo del documento.
        </li>
      </ul>
    </div>

    <!-- Boton de camara -->
    <button
      *ngIf="!currentImage"
      type="button"
      class="capture-button"
      (click)="openCameraModal($event)"
      [disabled]="loading"
    >
      Abrir camara
    </button>

    <!-- Modal de camara -->
    <div class="camera-modal" *ngIf="showCameraModal">
      <div class="camera-wrapper">
        <!-- Texto guia arriba -->
        <p class="camera-guide-text">Alinea tu documento dentro del marco</p>

        <div class="camera-container">
          <video #video autoplay playsinline></video>

          <!-- Marco de documento con esquinas -->
          <div class="document-frame">
            <div class="corner top-left"></div>
            <div class="corner top-right"></div>
            <div class="corner bottom-left"></div>
            <div class="corner bottom-right"></div>
          </div>
        </div>

        <!-- Botones debajo del video -->
        <div class="button-group">
          <button
            type="button"
            class="capture-button-overlay"
            (click)="captureDocument()"
          >
            Tomar foto
          </button>
          <button
            type="button"
            class="close-button"
            (click)="closeCameraModal()"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- Boton volver -->
    <div class="actions" *ngIf="!currentImage && !showCameraModal">
      <button type="button" class="back-btn" (click)="goBack()" [disabled]="loading">
        Volver
      </button>
    </div>
  </ng-container>

</div>
